import { AxiosResponse } from 'axios';
import { postRequest, putRequest } from '../../Services/HttpService';
import { TABLE_FUEL_CARD } from '../../Services/TableService';

const FuelCardsService = {
  async createFuelCard(values) {
    const url = `/v1/${TABLE_FUEL_CARD}/add`;

    const response: AxiosResponse | false = await postRequest(url, values, { returnAxiosResponse: true });

    if (response && response.data && response.status === 200) {
      return response;
    }
    if (response && response.data && response.status === 400) {
      return response;
    }

    return false;
  },
  async updateFuelCard(id: number | null, values) {
    const url = `/v1/${TABLE_FUEL_CARD}/${id}/edit`;

    const response: AxiosResponse | false = await putRequest(url, values, { returnAxiosResponse: true });

    if (response && response.data && response.status === 200) {
      return response;
    }
    if (response && response.data && response.status === 400) {
      return response;
    }

    return false;
  },
};

export default FuelCardsService;
